import { classNames } from '@/utils/helpers'

interface VideoItemProps {
  isActive: boolean
  title: string
  image: string
  duration: string
  date: string
  onClick: () => void
}

export const VideoItem = (props: VideoItemProps) => {
  const { isActive, title, image, duration, date, onClick } = props

  return (
    <div
      role="button"
      onClick={onClick}
      className={classNames(
        'flex items-center p-4 rounded-lg border-solid border cursor-pointer hover:border-primary-500/30 hover:bg-primary-500/5 transition-colors',
        {
          'border-primary-500': isActive,
        },
      )}
    >
      <div className="flex items-center justify-center relative">
        <img
          src={image}
          alt="video cover"
          className="max-w-[125px] aspect-video object-cover rounded-sm"
        />
      </div>
      <div className="flex items-start flex-col ml-4 max-sm:ml-2">
        <div
          className={classNames(
            'font-medium text-title text-base line-clamp-2',
            { 'text-primary-500': isActive },
          )}
        >
          {title}
        </div>
        <div className="flex gap-2">
          <div className="text-secondary-300 font-medium text-xs leading-5">
            {duration}
          </div>
          <div className="h-[20px] border-l" />
          <div className="text-secondary-300 font-medium text-xs leading-5">
            {date}
          </div>
        </div>
      </div>
    </div>
  )
}
